import { render } from "./StaffPositionForm.vue?vue&type=template&id=be8fee6a"
import script from "./StaffPositionForm.vue?vue&type=script&lang=js"
export * from "./StaffPositionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__